import { arrayOf, bool, shape, string, number } from 'prop-types';

const location = {
    Name: string,
    Address1: string,
    Address2: string,
    City: string,
    State: string,
    Zip: string,
    Country: string,
    FacilityGuid: string,
    Coordinates: shape({
        Latitude: number,
        Longitude: number
    }),
    PersonalLocation: bool
};

const DttTripShape = {
    PickUpLocation: shape(location),
    DropOffLocation: shape(location),
    DriverInfo: shape({
        DriverName: string,
        VehicleMake: string,
        VehicleModel: string,
        VehicleColor: string,
        VehicleLicense: string,
        DriverGender: string,
        DriverSubstituteFlag: bool,
        DriverGUID: string
    }),
    DueDateTLT: string,
    DueTimeTLT: string,
    DueDateTimeUTC: string,
    State: number,
    PassengerCapacity: string,
    ServiceLevel: string,
    OnsiteTLT: string,
    NoshowTLT: string,
    MemberGUID: string,
    MemberPII: shape({
        FirstName: string,
        LastName: string,
        ClientMemberCode: string
    }),
    TripNumber: number,
    VehicleRunID: number,
    TimeZone: string,
    IsEmulated: bool,
    ScheduledDropOffUTC: string,
    ScheduledDropOffTLT: string,
    dataVersion: number,
    commands: arrayOf(string),
    TripGuid: string,
    status: string
};

export default DttTripShape;